<template>
    <Breakpoints v-if="!isTunnelView">
        <template #max-sm>
            <MobilePageHeader/>
        </template>
        <template #min-md>
            <DesktopPageHeader/>
        </template>
    </Breakpoints>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import appStore from '@/core/app/app.store';
import MobilePageHeader from '@/project/layout/page-header/mobile/MobilePageHeader.vue';
import DesktopPageHeader from '@/project/layout/page-header/desktop/DesktopPageHeader.vue';

const isTunnelView = computed((): boolean => {
    return appStore.isTunnelView;
});
</script>
